export default __webpack_public_path__ + "static/media/thalia.60d95f3d.webp";